var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-simple-list-card',{attrs:{"title":_vm.title(_vm.value.type),"icon":_vm.icon,"items":_vm.items,"data-name":"address-block"}})}
var staticRenderFns = []

export { render, staticRenderFns }